.header {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  margin-bottom: 16px;
  background: var(--ant-color-bg-container);
  border-radius: var(--ant-border-radius-lg);
}

.heading {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: baseline;
  min-width: 0;
}
